import { render, staticRenderFns } from "./MyVimeoPlayer.vue?vue&type=template&id=0c86d41b&"
import script from "./MyVimeoPlayer.vue?vue&type=script&lang=js&"
export * from "./MyVimeoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports